import {
  ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT,
  ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR,
  CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT,
  CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function orderAssignmentCreateUrlDocumentReducer(state = initialState, action) {
  switch (action.type) {
    case ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
